export default function CTASection() {
  return (
    <section className="relative py-20 md:py-32 px-4 md:px-6 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=An%20artistic%20aerial%20view%20of%20a%20perfectly%20organized%20wardrobe%20with%20color%20coordinated%20clothing%20shoes%20and%20bags%20arranged%20in%20rainbow%20gradient%2C%20soft%20overhead%20lighting%2C%20satisfying%20organization%20porn%20photography%20with%20precise%20alignment%2C%20clean%20minimalist%20interior%20style&width=1600&height=900&seq=cta-v2-final-022&orientation=landscape"
          alt="Access the complete pandabuyspreadsheet database"
          title="PandabuySpreadsheet complete collection"
          className="w-full h-full object-cover object-top"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-50/90 via-background-50/70 to-background-50/90"></div>
      </div>

      <div className="relative z-10 max-w-3xl mx-auto text-center">
        <span className="inline-block px-3 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold tracking-wide uppercase mb-5">
          Get Started Now
        </span>
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-900 leading-tight mb-6 text-balance">
          Start Using the Most Complete <span className="italic text-primary-500">PandabuySpreadsheet</span> System
        </h2>
        <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto mb-10 leading-relaxed">
          Join thousands of savvy shoppers who trust our curated pandabuy spreadsheet for the best fashion finds. Free and updated daily.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-4 rounded-full bg-primary-500 text-background-50 text-sm md:text-base font-semibold hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            Pandabuy Sheet
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-4 rounded-full bg-foreground-900 text-background-50 text-sm md:text-base font-semibold hover:bg-foreground-800 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            Buy It Now
          </a>
        </div>

        <p className="mt-6 text-xs text-foreground-400 font-medium">Free &amp; Updated Daily · No Account Required</p>
      </div>
    </section>
  );
}